const reviews = [
    {
        author_name: "Michel",
        rating: 5,
        text: "Cet après-midi, CC Débaras est venu vider un studio. Ils sont arrivés pile à l'heure ! Avec le sourire et une gentillesse incroyable.\n\nIls sont organisés, efficaces et travaillent très bien. Ils évitent tout bruit inutile, eteignent les lumières et referment les portes derrière eux.\n\nJe les recommande absolument car, en plus, ils ont pu se libérer dans les 48h, et sont venus un dimanche.\n\nMerci à cette super équipe !",
        source: "Site internet"
    },
    {
        author_name: "Laurie",
        rating: 5,
        text: "Excellent service !\n\nL’équipe a été très professionnelle, ponctuelle, efficace et en plus très sympathique. Le démontage de mon énorme buffet s’est fait rapidement et proprement, alors que je ne savais pas du tout comment m’en débarrasser seule.\n\nTout a été pris en charge du début à la fin avec beaucoup de sérieux.\n\nJe recommande cette entreprise les yeux fermés et je referai appel à eux sans hésiter si besoin. \nMerci encore pour votre aide et votre gentillesse !",
        source: "Google"
    },
    {
        author_name: "Charles",
        rating: 5,
        text: "Impeccable.\n\nRapidité d'intervention, gentillesse, professionnalisme.",
        source: "Google",
        featured: 1
    },
    {
        author_name: "Katia",
        rating: 5,
        text: "Efficaces et sympathiques, merci pour la prestation.",
        source: "Google"
    },
    {
        author_name: "Eric",
        rating: 5,
        text: "Ma demande a été très vite prise en charge et planifiée à ma convenance pour un tarif raisonnable.\n\nL’équipe qui s’est présentée était à la fois très sympathique, dynamique, respectueuse de mon domicile et efficace !\n\nJe recommande vraiment !!",
        source: "Google"
    },
    {
        author_name: "Al",
        rating: 5,
        text: "Très bon service.\n\nLes 2 personnes qui sont venues étaient efficaces et très sympathiques. On a beaucoup aimé leur manière de travailler. \n\nTravail bien fait et discret. \n\nJe recommande",
        source: "Google"
    },
    {
        author_name: "Michel",
        rating: 5,
        text: "Très professionnels.\n\nHyper organisés.\n\nJe recommande fortement",
        source: "Google"
    },
    {
        author_name: "Jack",
        rating: 5,
        text: "Travail ponctuel et rapide. \nParfait. \n\nN'hésitez pas à contacter CC Débarras 14.",
        source: "Google"
    },
    {
        author_name: "Guy",
        rating: 5,
        text: "J'avais deux très grands miroirs fixés au mur à débarrasser.\n\nLundi 1er juin, ils sont venus à l'heure du rendez-vous.\n\nJ'ai apprécié qu'ils soient venus quelques jours auparavant pour savoir de quoi il s'agissait exactement.\n\nPonctualité, gentillesse, sourire, efficacité et professionnalisme étaient au rendez-vous!\n\nLe tout pour un prix modique.\n\nJe recommande vivement cette entreprise pour laquelle il n'y a rien à rajouter: parfait!",
        source: "Google"
    },
    {
        author_name: "Carla",
        rating: 5,
        text: "Je recommande vivement CC Débarras 14 !\n\nIl est venu récupérer un mini-frigo et s’est montré très disponible, ponctuel et professionnel.\n\nTout s’est déroulé rapidement et efficacement.\n\nJe garde précieusement ses coordonnées et je n’hésiterai pas à faire appel à lui de nouveau.\n\nMerci encore pour votre sérieux !",
        source: "Google"
    },
    {
        author_name: "Edouard",
        rating: 5,
        text: "Une super équipe professionnelle et sympathique à votre service.\n\nJe recommande chaudement cette entreprise pour tous vos besoins.\n\nJ’ai pu caler un rdv très rapidement dès ma prise de contact.\n\nTout s’est passé comme sur des roulettes le Jour J :)",
        source: "Google"
    },
    {
        author_name: "Isabelle",
        rating: 5,
        text: "Nous sommes ravis de la prestation de cc débarras pour notre appartement sur Deauville. \n\nDes personnes très gentilles et compétentes. \n\nÀ RECOMMANDER",
        source: "Google",
        featured: 4
    },
    {
        author_name: "Michel",
        rating: 5,
        text: "Rapidité d'intervention super, enlèvement de mon encombrant vite et bien.\n\nLa bonne humeur \n\nLe tout mérite 6 sur 5",
        source: "Google",
        featured: 2
    },
    {
        author_name: "Bruno",
        rating: 5,
        text: "Bravo à vous et à toute votre équipe, un travail exceptionnel et de qualité avec une rapidité au top je recommande à 1000 %. \n\nMerci beaucoup.",
        source: "Google",
        featured: 3
    },
];

export default reviews;
